export default class CourseRunApi {

    constructor(api) {
        this.api = api;
    }

    assign(companyId, courseId, users, callback, error) {
        let appendix = companyId !== null ? "?companyId=" + companyId : "";
        this.api.getRaw((axios) => {
            axios.post("courserun/" + courseId + appendix, users).then(() => {
                callback();
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

    reassign(companyId, courseId, users, callback, error) {
        let appendix = companyId !== null ? "?companyId=" + companyId : "";
        this.api.getRaw((axios) => {
            axios.post("courserun/" + courseId + "/reassign" + appendix, users).then(() => {
                callback();
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

    remove(companyId, courseId, users, callback, error) {
        let appendix = companyId !== null ? "?companyId=" + companyId : "";
        this.api.getRaw((axios) => {
            axios.delete("courserun/" + courseId + appendix, {data: users}).then(() => {
                callback();
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

}
